import { NgModule } from '@angular/core';
import { ScrollObserverDirective } from './scroll-observer.directive';
import { HeaderComponent } from './header.component';
import { SharedModule } from '../_shared/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SliceHoverDirective } from './slice-hover.directive';
import { RouterModule } from '@angular/router';
import { SliceProgressDirective } from './slice-progress.directive';
import { LottieModule } from 'ngx-lottie';
import { OverlayModule } from '@angular/cdk/overlay';
import { HistoryComponent } from '../history/history.component';
import { DisabledSliceDirective } from './disabled-slice.directive';
import { ScoreDirective } from './score.directive';

@NgModule({
  declarations: [
    ScrollObserverDirective,
    HeaderComponent,
    SliceHoverDirective,
    SliceProgressDirective,
    DisabledSliceDirective,
    ScoreDirective,
  ],
  imports: [
    SharedModule,
    MatToolbarModule,
    RouterModule,
    LottieModule,
    OverlayModule,
    HistoryComponent,
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {}
